import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import { CILDashboardService } from 'src/app/services/cil-dashboard-service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Chart } from 'angular-highcharts';
import { Options } from 'highcharts';
import { DtServiceService } from 'src/app/services/dtService.service';
import { data } from 'jquery';
import { differenceInCalendarDays } from 'date-fns';
import { CustomLoadingOverlay } from 'src/app/custom-loading-overlay.component';
import { CILMasterService } from 'src/app/services/cil-master-service';
import { BtnCellRendererNewCilDashBoard } from 'src/app/btn-cell-rendererNewCilDashBoard.component';
import { CilConfigurationService } from 'src/app/services/cil-configuration.service';
import { Multilingual } from 'src/app/services/multilingual';
import { filter } from 'lodash-es';
import { element } from 'protractor';
import { BaseApi } from 'src/backend/api/base-api';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
import Highcharts from 'highcharts';
@Component({
  selector: 'app-new-cil-dashboard',
  templateUrl: './new-cil-dashboard.component.html',
  styleUrls: ['./new-cil-dashboard.component.scss'],
})
export class NewCilDashboardComponent implements OnInit {
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('displayResponsibleModal') private displayResponsibleModal!: TemplateRef<any>;
  todayDate = new Date();
  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.todayDate) > 0;
  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  public date: moment.Moment | undefined;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  filteredGroups: any;
  filteredPlants: any;
  filteredLines: any[] = [];
  filteredUnits: any;
  filteredComponents: any;
  breadcrumList: any;
  moduleId!: any;
  pageId!: any;
  IsAccess: any;
  IsWrite: any;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  componentList!: any;
  permisson!: any;
  CLLDashboardForm!: FormGroup;
  CILTask!: any;
  key: any;
  lang: any;
  responseLineData!: any;
  responseUnitData!: any;
  linepercentageGraphData: any = [];
  unitpercentageGraphData: any = [];
  dashboardData: any;

  chartCILTask!: Chart;
  chartCILType!: Chart;
  chartCILTool!: Chart;
  chartLinePercentage!: Chart;
  options!: any;
  options2!: any;
  image!: any;
  currentImagePath!: any;
  defaultExcelExportParams: any;
  frameworkComponents: any;

  rowData!: any[];
  columnDefs!: any[];
  gridApi: any;
  gridColumnApi: any;

  languageDir = 'ltr';
  langObj: any = {};
  gridOptions: any = {
    defaultColDef: {
      paginationPageSize: 5,
      infiniteInitialRowCount: 2,
      flex: 1,
      sortable: true,
      resizable: true,
      wrapText: false,     // <-- HERE
      autoHeight: true,   // <-- HERE
      minWidth: 225,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
      // tooltipComponent: CustomTooltip,
    },
    // headerHeight: 150,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      customLoadingOverlay: CustomLoadingOverlay,
      BtnCellRendererNewCilDashBoard: BtnCellRendererNewCilDashBoard
    },
    // floatingFilter: true,
  };
  // iconUrl
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';
  dashboarUnitData: any;
  dashboardLineData: any;
  deparmentList: any;
  deparmentFiltList: any;
  chartUnitPercentage: Chart;
  completeUnitList: any;
  completeDepartmentList: any;
  completeLineList: any;
  completeCompentList: any;
  overlayLoadingTemplate =
    '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
  loadingOverlayComponent: any;
  frequencyDropList!: any[];
  AssignedUsers: any;
  TotalDefects!: any;
  TotalDefecteSolved!: any;
  TotalDefectsPerc!: any;
  CILAdherence!: any;
  isSelectedLine = false;
  isSelectedFrequency = false;
  plantSession: any;
  userSession: any;
  groupSession: any;
  isAccess = ApplicationPermission.New_CILDashboard_ACCESS;
  isCreate = ApplicationPermission.New_CILDashboard_CREATE;
  isUpdate = ApplicationPermission.New_CILDashboard_UPDATE;
  isDelete = ApplicationPermission.New_CILDashboard_DELETE;
  constructor(
    private baseApi: BaseApi,
    private formBuilder: FormBuilder,
    private productivityservice: ProductivityService,
    private cilService: CILDashboardService,
    private toaster: ToastrService,
    public router: Router,
    private userService: UserManagementService,
    private enterpriseGroupService: EnterPriseGroupService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    public translater: TranslaterService,
    public translate: TranslateService,
    private dtService: DtServiceService,
    private cilMasterService: CILMasterService,
    private cilService2: CilConfigurationService,
  ) {
    this.loadingOverlayComponent = 'customLoadingOverlay';
    this.frameworkComponents = {
      buttonRenderer: ButtonViewRendererComponent,
    };
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.columnDefs = [
      {
        headerName: 'Line',
        field: 'Pl_Desc',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      }
      ,
      {
        headerName: 'Task Name',
        field: 'taskName',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'User Name',
        field: 'UserName',
        filter: true,
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Responsible',
        field: 'Responsible',
        colId: 'Responsible',
        cellRenderer: 'BtnCellRendererNewCilDashBoard',
        suppressExport: true, // Prevent this column from being exported
        headerValueGetter: this.localizeHeader.bind(this),
        filter: true,
        sortable: true,
        resizable: true,
        wrapText: true,
        maxWidth: 150
      },
      {
        headerName: 'Machine',
        field: 'Machine',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Assembly',
        field: 'Assembly',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Sub Assembly',
        field: 'SubAssembly',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Component',
        field: 'Component',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Task Status',
        field: 'Status',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Task Start Time',
        field: 'TaskStartTime',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: function (params: any) {
          return params.value !== null
            ? moment(params.value, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
      },
      {
        headerName: 'Task End Time',
        field: 'TaskEndTime',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this),
        valueFormatter: function (params: any) {
          return params.value !== null
            ? moment(params.value, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
            : '';
        },
      },
      {
        headerName: 'Type',
        field: 'Type',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Start Time',
        field: 'StartTime',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
        // valueFormatter: function (params: any) {
        //   return params.value !== null
        //     ? moment(params.value).format('MM/DD/YYYY HH:mm:ss')
        //     : '';
        // },
      },
      {
        headerName: 'End Time',
        field: 'EndTime',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
        // valueFormatter: function (params: any) {
        //   return params.value !== null
        //     ? moment(params.value).format('MM/DD/YYYY HH:mm:ss')
        //     : '';
        // },
      },
      {
        headerName: 'Executed By',
        field: 'ExecutedBy',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Estimated Time',
        field: 'EstimatedTime',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Remarks',
        field: 'Remarks',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Post Remarks',
        field: 'postRemarks',
        filter: true,
      },
      {
        headerName: 'Frequency',
        field: 'Frequency',
        filter: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'PreImage',
        field: 'PreTaskImage',
        cellRenderer: function (params: any) {
          return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value
            }" src="${params.value !== ''
              ? params.value
              : 'assets/images/no-image.png'
            }">`;
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'PostImage',
        field: 'Postimage',
        cellRenderer: function (params: any) {
          return `<img style="width:40px;height:40px ;cursor:pointer" alt="${params.value
            }" src="${params.value !== ''
              ? params.value
              : 'assets/images/no-image.png'
            }">`;
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
    ];
    this.defaultExcelExportParams = {
      addImageToCell: function (
        rowIndex: number,
        col: any,
        value: any,
        callback: any
      ) {
        if (col.colId === 'PreImage' || col.colId === 'PostImage') {
        } else {
          return;
        }
      },
    };
  }

  ngOnInit(): void {
    this.plantSession = this.baseApi?.getPlantFromStorage();
    this.userSession = this.baseApi?.getUserSession();
    this.groupSession = this.baseApi?.getGroupFromStorage();
    this.getLangWords();
    this.getAllListCilDasboard();

    this.initform();
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    this.moduleId = this.baseApi.getUserPermissionsSession().find(x => x.menuId == this.pageId)?.parentId
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  initform() {
    const dateStart = new Date(moment().subtract(1, 'd').toString());
    //dateStart.setDate(dateStart.getDate() - 183);
    // dateStart.setHours(6);
    // dateStart.setMinutes(0);
    // dateStart.setSeconds(0);

    const dateEnd = new Date();
    dateEnd.setDate(dateEnd.getDate());
    this.CLLDashboardForm = this.formBuilder.group({
      UserGroup1: ['', Validators.required],
      UserPlant1: ['', Validators.required],
      unit: ['', Validators.required],
      line: ['', Validators.required],
      components: ['', Validators.required],
      frequency: [''],
      datePicker: [[dateStart, dateEnd]],
      // dateStart: [new Date(), Validators.required],
      // dateEnd: [new Date(), Validators.required],

      shift: ['', []],
    });
    this.CLLDashboardForm.controls.unit.patchValue('0');
    this.CLLDashboardForm.controls.components.patchValue('0');
    this.CLLDashboardForm.controls.line.patchValue('0');
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.userService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId =
          this.breadcrumList && this.breadcrumList.length
            ? this.breadcrumList[0].id
            : '';
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.permisson = data;
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  // datasource(): void {
  //   const key = {
  //     UserId: JSON.parse(localStorage.user).UserId,
  //   };
  //   const id = {
  //     value: 0,
  //   };
  //   this.productivityservice.getGroupData(key).subscribe(
  //     (data: any) => {
  //       this.GroupList = data.lstEG;
  //       id.value = data.lstEG[0].EG_Id;
  //       this.CLLDashboardForm.get('UserGroup1')?.setValue(data.lstEG[0].EG_Id);
  //       this.CLLDashboardForm.get('UserPlant1')?.setValue(data.lstEG[0].EG_Id);
  //       this.filteredGroups = this.GroupList.slice();
  //       //this.getPlants(id);
  //     },
  //     (error: any) => {
  //       this.toaster.error('error', error.message);
  //     }
  //   );
  // }
  getAllListCilDasboard() {
    const key = {
      PlantCode: this.plantSession?.plantCode
    }
    this.cilService.getAllListCilDasboard(key).subscribe((res) => {
      if (res) {

        this.CLLDashboardForm.controls.components.patchValue('0');
        this.getUnitFromList(res);
        this.getLineFromList(res);
        this.getCilFrequency();
        // this.getDepartmentFromList(res);

      }

    },
      (error) => {
        this.toaster.error('error', 'Something Went Wrong')
      });
  }

  getUnitFromList(res: any): void {
    let array = [];
    const arrayId = [...new Set(res?.map((elem) => {
      return elem.PU_ID
    }))]
    arrayId?.forEach((elem) => {
      const obj = res?.find((elem2: any) => {
        if (elem2.PU_ID === elem) {
          return {
            PU_ID: elem2.PU_ID,
            PU_Desc: elem2.PU_Desc
          }
        }
      })
      array.push(obj)
    })
    const UnitArray = array.map((elem) => {
      return {
        PU_Id: elem.PU_ID,
        PU_Desc: elem.PU_Desc,
        PL_Id: elem.PL_Id,
      }
    })
    this.unitList = UnitArray;
    this.CLLDashboardForm?.controls?.unit.patchValue(this.unitList[0]?.PU_Id);
    this.completeUnitList = UnitArray
    this.filteredUnits = this.unitList.slice();
  }

  getLineFromList(res: any): void {
    let array = [];
    const arrayId = [...new Set(res?.map((elem) => {
      return elem.PL_Id
    }))]
    arrayId?.forEach((elem) => {
      const obj = res?.find((elem2: any) => {
        if (elem2.PL_Id === elem) {
          return {
            PL_Id: elem2.PL_Id,
            PL_Desc: elem2.PL_Desc,
          }
        }
      })
      array.push(obj)
    })
    const LineArray = array?.map((elem) => {
      return {
        PL_Id: elem.PL_Id,
        PL_Desc: elem.PL_Desc,
        TypeId: elem.Dept_Id,
      }
    })
    this.lineList = LineArray;
    this.CLLDashboardForm?.controls?.line.patchValue([this.lineList[0]?.PL_Id]);
    this.completeLineList = this.lineList;
    this.filteredLines = this.lineList.slice();
  }

  // onChangeGroup(data: any): void {
  //   this.getPlants(data.value);
  // }

  onChangePlant(data: any) {
    this.getAllListCilDasboard();
    this.CLLDashboardForm?.controls?.line.patchValue('0');
    this.CLLDashboardForm?.controls?.unit.patchValue('0');

  }

  onChangeLine(data: any): void {
    if (parseInt(data.value) === 0) {
      this.filteredLines?.forEach(elem2 => {
        this.completeUnitList.filter(elem => elem.PL_Id === elem2.PL_Id)?.forEach(element => {
          this.unitList.push(element)
        });
      });
      this.filteredUnits = this.unitList.slice();
      // this.filteredUnits?.length = 0;
      // this.filteredComponents?.length = 0;
      this.CLLDashboardForm?.controls?.unit.patchValue('0');
      this.CLLDashboardForm.controls.components.patchValue('0');
      // this.getUnit(parseInt(data.value));


    } else {
      this.unitList = this.completeUnitList.filter(elem => elem.PL_Id === data.value);
      this.filteredUnits = this.unitList.slice();
      this.CLLDashboardForm?.controls?.unit.patchValue('0');
      this.CLLDashboardForm.controls.components.patchValue('0');
      // this.getUnit(data.value);

    }
  }

  selectAllLines() {
    this.isSelectedLine = !this.isSelectedLine;

    if (this.isSelectedLine) {
      const filterdArray = this.filteredLines?.map(
        (item: any) => item?.PL_Id
      );
      this.CLLDashboardForm
        .get('line')
        ?.setValue([...filterdArray, '0']);
    } else {
      this.CLLDashboardForm.get('line')?.setValue([]);
    }
  }

  onChangeUnit(data: any): void {
    this.componentList = this.completeCompentList.filter(elem => elem.PU_Id = data.value);
    const comDefault = this.componentList[0];
    this.componentList.length !== 0
      ? this.CLLDashboardForm.controls.components.patchValue(
        comDefault.ComponentId
      )
      : this.CLLDashboardForm.controls.components.patchValue('0');
    this.filteredComponents = this.componentList.slice();
    // this.getComponent(data.value);
  }

  getCilFrequency() {
    const key = {
      GroupCode: this.groupSession?.groupCode,
      PlantCode: this.plantSession?.plantCode,
    };
    this.cilMasterService.getCILFrequencyList(key).subscribe(
      (response: any) => {
        if (response.HasError === false) {
          this.frequencyDropList = response.dropDownList;
          this.CLLDashboardForm.get('frequency').setValue([this.frequencyDropList[0].id]);
          this.getData();

        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  getData() {
    this.getAMCILDashboard();
    this.getNewCilDashBoardReport();
  }

  selectAllFrequency() {
    this.isSelectedFrequency = !this.isSelectedFrequency;

    if (this.isSelectedFrequency) {
      const filterdArray = this.frequencyDropList?.map(
        (item: any) => item?.id
      );
      this.CLLDashboardForm
        .get('frequency')
        ?.setValue([...filterdArray, '0']);
    } else {
      this.CLLDashboardForm.get('frequency')?.setValue([]);
    }
  }

  getAMCILDashboard() {
    this.spinner.show();
    this.dashboarUnitData = [];
    this.dashboardLineData = [];
    this.dashboardData = [];
    this.linepercentageGraphData = [];
    this.unitpercentageGraphData = [];
    const dateStart = new Date(this.CLLDashboardForm.get('datePicker').value[0]);
    dateStart.setSeconds(0, 0);

    this.key = {
      //groupId: this.CLLDashboardForm.value.UserGroup1,
      PTCode: this.plantSession?.plantCode,
      PUID: 0,
      PLID: this.CLLDashboardForm.value.line?.toString(),
      dateStart: dateStart,
      dateEnd: this.CLLDashboardForm.get('datePicker').value[1],
      FrequencyId: this.CLLDashboardForm.value.frequency?.toString(),
    };



    this.cilService.getNewCILDashboard(this.key).subscribe(
      (data: any) => {
        this.spinner.hide();
        this.responseUnitData = data.CILDashUnitList;
        this.dashboardData = data;
        this.spinner.hide();

        this.responseLineData = data.CILDashDeptList
        this.responseUnitData = data.CILDashUnitList;
        this.dashboardData = data;
        this.manageData(data);
      },
      (error: any) => {
        this.toaster.error('error', error.message);
        this.spinner.hide();
      }
    );
  }

  manageData(data: any): any {
    let cilTaskChartObj = {
      drillDownObj: null,
      seriesObj: null,
      name: 'Line'
    };
    cilTaskChartObj.drillDownObj = this.setDrillDownData(data.CILDashUnitList);
    cilTaskChartObj.seriesObj = this.setSeriesData(data.CILDashDeptList);
    this.drawCilTaskChart(cilTaskChartObj);
    this.setCalculation(data.CILDashDeptList);
  }

  setCalculation(param: any) {
    let lineArray = param;
    let totalFound = 0;
    let totalDone = 0;
    let totalNotDone = 0;
    let Adherence = '0';
    if (lineArray?.length > 0) {
      lineArray?.forEach((lineObj: any) => {
        totalFound = totalFound + lineObj.TotalCount;
        totalDone = totalDone + lineObj.Done;
      });
    }
    totalNotDone = totalFound - totalDone;
    if (totalDone != 0) {
      Adherence = (totalDone / totalFound * 100).toFixed(2) + '%';
    }
    this.TotalDefects = totalFound;
    this.TotalDefecteSolved = totalDone;
    this.TotalDefectsPerc = totalNotDone;
    this.CILAdherence = Adherence;
  }

  setDrillDownData(param: any): any {
    const key = param;
    let unitObj = {};
    key?.forEach((elem: any) => {
      let flag = false;
      const foundObj = {
        name: elem.Name,
        y: elem.TotalCount,
      }
      const fixObj = {
        name: elem.Name,
        y: elem.Done,
      }
      const aderenceObj = {
        name: elem.Name,
        y: parseInt((
          (parseInt(elem.Done) / parseInt(elem.TotalCount)) *
          100
        ).toFixed(2))
      }
      flag = unitObj.hasOwnProperty(elem.PL_Desc)
      if (flag) {
        unitObj[elem.PL_Desc].data.push(fixObj)
        unitObj[elem.PL_Desc + '2'].data.push(foundObj)
        unitObj[elem.PL_Desc + '3'].data.push(aderenceObj)
      }
      else {
        Object.assign(unitObj, {
          [elem.PL_Desc]: {
            name: 'Task Executed',
            color: '#0ced9b',
            id: 'Line',
            data: [
              fixObj
            ],
          }
        });
        Object.assign(unitObj, {
          [elem.PL_Desc + '2']: {
            name: 'Task Scheduled',
            color: '#3068e8',
            id: 'Line',
            data: [
              foundObj
            ],
          }
        });
        Object.assign(unitObj, {
          [elem.PL_Desc + '3']: {
            name: 'Adherence %',
            color: '#55BF3B',
            id: 'Line',
            data: [
              aderenceObj
            ],
            dataLabels: {
              format: '{y}'
            },
          }
        });
      }
    });
    return unitObj;
  }


  setSeriesData(param: any): any {
    const lineArray = param;
    const foundObj = {
      name: 'Task Scheduled',
      data: [],
      color: '#3068e8',
    }
    const fixObj = {
      name: 'Task Executed',
      data: [],
      color: '#0ced9b',

    }
    const adherenceObj = {
      name: 'Adherence %',
      data: [],
      color: '#55BF3B',
    }
    const SeriesArray = [];
    lineArray?.forEach((lineElement: any) => {
      const foundDrillDownObj = {
        name: lineElement.Name,
        y: lineElement.TotalCount,
        drilldown: true,
      }
      foundObj?.data.push(foundDrillDownObj);
      const fixDrillDownObj = {
        name: lineElement.Name,
        y: lineElement.Done,
        drilldown: true,
      }
      fixObj?.data.push(fixDrillDownObj);
      const val = parseInt((
        (parseInt(lineElement.Done) / parseInt(lineElement.TotalCount)) *
        100
      ).toFixed(2))

      const aderenceObj = {
        name: lineElement.Name,
        y: parseInt((
          (parseInt(lineElement.Done) / parseInt(lineElement.TotalCount)) *
          100
        ).toFixed(2)),
        dataLabels: {
          format: '{y}'
        },
        drilldown: true,
      }
      adherenceObj?.data.push(aderenceObj)
    });
    SeriesArray?.push(adherenceObj);
    SeriesArray?.push(fixObj);
    SeriesArray?.push(foundObj);
    // console.log('series' , SeriesArray)
    return SeriesArray;
  }



  drawCilTaskChart(param) {
    // console.log('paramS', param)
    this.options = {
      chart: {
        type: 'bar',
        height: 600,
        scrollablePlotArea: {
          minHeight: 600,
          scrollPositionY: 0,
          opacity: 1
        },
        style: {
          overflow: 'visible'
        },
        events: {
          drilldown: function (e) {
            if (!e.seriesOptions) {
              let chart = this,
                drilldowns = param.drillDownObj,
                series = [
                  drilldowns[e.point.name],
                  drilldowns[e.point.name + '2'], drilldowns[e.point.name + '3'],
                ];
              // console.log('series123' , series);
              
              // Calculate the number of units in the drilldown
              let unitCount = series[0]?.data?.length || 0;
              
              // Calculate dynamic height: 40px per unit + 200px for margins/legend/title
              let calculatedHeight = (unitCount * 40) + 200;
              
              // Max height of 1200px, but scrollable content can be larger
              let maxChartHeight = 1200;
              
              series?.forEach((element: any, index) => {

              })
              chart.addSingleSeriesAsDrilldown(e.point, series[2]);
              chart.addSingleSeriesAsDrilldown(e.point, series[0]);
              chart.addSingleSeriesAsDrilldown(e.point, series[1]);
              // Object.assign(chart.drilldown , b )
              chart.applyDrilldown();
              
              // Update x-axis title to 'Unit'
              chart.xAxis[0].update({
                title: {
                  text: 'Unit',
                  align: 'high',
                  offset: 0,
                  rotation: 0,
                  y: -10,
                  x: 0,
                  style: {
                    fontSize: 20,
                    fontWeight: 'bold'
                  }
                },
                
              }, false);
              
              // Update chart with max height but scrollable content
              chart.setSize(null, Math.min(maxChartHeight, calculatedHeight), false);
              chart.update({
                chart: {
                  scrollablePlotArea: {
                    minHeight: calculatedHeight,
                    scrollPositionY: 0,
                    opacity: 1
                  }
                }
              }, true);
              
              var element3: any = document.getElementsByClassName('highcharts-drillup-button');
              element3[0].children[1].innerHTML = '◁ Back to Line '
            }
          },
          drillup: function (e) {
            // Update x-axis title back to 'Line'
            var element: any = document.getElementsByClassName("highcharts-axis-title");
            // console.log('unit' , this)
            element[0].innerHTML = 'Line'
          },

        },
      },
      title: {
        text: 'Cil Task',
      },
      xAxis: {
        type: 'category',
        title: {
          align: 'high',
          offset: 0,
          text: 'Line',
          rotation: 0,
          y: -10,
          x: 0,
          style: {
            fontSize: 20
          }
        },
      
        // offset: 10,
        // lineWidth: 5,
        // lineColor: '#494945'
      },
      yAxis: {
        visible: false
      },

      legend: {
        enabled: true,
        reversed: true,
        verticalAlign: "top",
        zIndex: 10
      },
      tooltip: {
        shared: false,
        useHTML: true,
        formatter(): any {
          // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
          let s = '<div style="padding: 5px;">';
          s += '<b>' + this.point.category + '</b><br/>';
          if (this.point.series.name == 'Adherence %') {
            s += this.point.series.name + ': <b>' + this.point.y + " %</b>"
          }
          else {
            s += this.point.series.name + ': <b>' + this.point.y + " Task</b>"
          }
          s += '</div>';
          return s;
        },
      },
      plotOptions: {
        column: {
        },
        series: {
          stacking: 'percent',
          pointWidth: 20,
          groupPadding: 0.05,
          pointPadding: 0.1,
          events: {
            click: function (event) {
              param.name = 'Unit';
              var element: any = document.getElementsByClassName("highcharts-axis-title");
              element[0].innerHTML = 'Unit';
            }
          }
        },
        bar: {
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            color: '#000000'
          }
          // events
        }
      },
      credits: {
        enabled: false
      },
      drilldown: {
        breadcrumbs: {
          // showFullPath: false,
          format: 'Back to Region',
        },
        drillUpButton: {
          relativeTo: 'spacingBox',
          position: {
            y: 40,
            x: -100
          },
        },
      },
      series: param.seriesObj,
    }
    // console.log('upper ', this.options);
    let chart = new Chart(this.options);
    this.chartCILType = chart;
    const widthTwo = document.querySelectorAll('div.chart-items-l');
    if (widthTwo && widthTwo.length) {
      widthTwo.forEach((node: any) => (node.style.width = '100%'));
    }
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridColumnApi.autoSizeAllColumns();
    // this.gridApi.setDomLayout('autoHeight');
    // const e: HTMLElement = document.querySelector('#eGrid') as HTMLElement;
    // if (e !== null) {
    //   e.style.height = '';
    // }
    // this.getCILDashboard();
  }

  autosizeAll() {
    this.gridColumnApi.autoSizeAllColumns();
  }


  getNewCilDashBoardReport(): void {
    const dateStart = new Date(this.CLLDashboardForm.get('datePicker').value[0]);
    dateStart.setSeconds(0, 0);
    const key = {
      //groupId: this.CLLDashboardForm.value.UserGroup1,
      PTCode: this.plantSession?.plantCode,
      PUID: 0,
      PLID: this.CLLDashboardForm.value.line?.toString(),
      dateStart: dateStart,
      dateEnd: this.CLLDashboardForm.get('datePicker').value[1],
      FrequencyId: this.CLLDashboardForm.value.frequency?.toString(),
    };
    // this.rowData = []
    this.gridApi.showLoadingOverlay();
    this.cilService.getNewCilDashBoardReport(key).subscribe((response: any) => {
      response?.ReportData?.forEach((elem: any, i) => {
        if (elem.Status) {
          response.ReportData[i].Status = 'Executed';
        }
        else {
          response.ReportData[i].Status = 'Not Executed';
        }
        if (elem.StartTime) {
          response.ReportData[i].StartTime = moment(elem.StartTime).format('DD/MM/YYYY HH:mm:ss')
        }
        if (elem.EndTime) {
          response.ReportData[i].EndTime = moment(elem.EndTime).format('DD/MM/YYYY HH:mm:ss')
        }
        if (elem.TaskStartTime) {
          response.ReportData[i].TaskStartTime = moment(elem.TaskStartTime).format('DD/MM/YYYY HH:mm:ss')
        }
        if (elem.TaskEndTime) {
          response.ReportData[i].TaskEndTime = moment(elem.TaskEndTime).format('DD/MM/YYYY HH:mm:ss')
        }
      });
      this.gridOptions.api.hideOverlay()
      // this.rowData = response?.ReportData;
      this.gridApi.setRowData(this.rowData);
      this.gridApi.setRowData(response?.ReportData);
      this.autosizeAll();
    })
  }

  cellClicked(params: any): void {
    const col = params.colDef.field;
    if (col === 'Postimage') {
      this.image = params.data.Postimage;
      this.openPictureBeforeModal();
    }
    if (col === 'PreTaskImage') {
      this.image = params.data.PreTaskImage;
      this.openPictureBeforeModal();
    }
    if (col === 'Responsible') {
      this.getTaskAssignedUsers(params.data.taskId);
    }
  }

 excelExport() {
  // Build list of fields to export (exclude the visible Responsible column if needed)
  const exportColumns = this.columnDefs
    .filter(col => col.field && col.field !== 'Responsible') // exclude actual Responsible field
    .map(col => col.field);
  this.gridApi.exportDataAsExcel({
    // only export the specified columns
    columnKeys: exportColumns,
    allColumns: false,
    // Header transformation (rename UserName -> Responsible, and apply translations)
    processHeaderCallback: (params) => {
      const colDef = params.column.getColDef();
      const field = colDef.field;
      // Rename UserName to Responsible in exported header
      if (field === 'UserName') {
        return this.getTransalatedValue('Responsible') || 'Responsible';
      }
      // Try translated label for the field, fallback to headerName or field
      return this.getTransalatedValue(field) || colDef.headerName || field;
    },
    // Cell transformation (format date columns as DD/MM/YYYY HH:mm:ss)
    processCellCallback: (params) => {
      const colId = params.column.getColId ? params.column.getColId() : params.column.colId;
      if (!params.value) {
        return params.value;
      }
      const dateCols = ['TaskStartTime', 'TaskEndTime', 'StartTime', 'EndTime'];
      if (dateCols.includes(colId)) {
        // Ensure moment is available; if incoming value is UTC you can use moment.utc(...)
         const m = moment(params.value, 'DD/MM/YYYY HH:mm:ss', true);
          return m.isValid()
            ? m.format('DD/MM/YYYY HH:mm:ss')
            : params.value;
      }
      return params.value;
    },
    // spread any other default export params you use (styles, sheetName, etc.)
    ...this.defaultExcelExportParams
  });
}

  csvExport() {
    this.gridApi.exportDataAsCsv();
  }

  getTaskAssignedUsers(param: any): void {
    this.spinner.show();
    const key = {
      PlantCode: this.plantSession?.plantCode,
      TaskId: param
    };
    this.cilService2.getTaskAssignedUsers(key).subscribe(
      (response: any) => {
        this.spinner.hide();
        this.dialog.open(this.displayResponsibleModal, { height: 'auto', width: '45%', maxHeight: '50vh' });
        this.AssignedUsers = response?.data;
        // this.getTaskList();
      });
  }

  openPictureBeforeModal(): void {
    this.currentImagePath =
      this.image === ''
        ? 'assets/images/no-image.png'
        : this.image;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  imageZoomModal(imagePath: String): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }


}
